import React, { Fragment, useEffect, useState } from "react";
import classnames from "classnames";
import { useDispatch } from "react-redux";
import { Container, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import Breadcrumb from "../../../../layout/breadcrumb";
import withReducer from "../../../../store/withReducer";
import partnerReducer from "../../store";
import { getCourierServiceCostDeliveryPartners } from "../../store/courierServiceCostSlice";
import CarrierDefaultsTab from "./carrierDefaultsTab";
import PairRateTab from "./pairRateTab";
import ServiceCostsTab from "./serviceCostsTab";

const shippingRatesConfig = {
  resource: "shipping-rates",
  title: "Shipping Method Rate",
  lookup: "shippings",
  secondKey: "shipping_id",
  secondNameKey: "shipping_name",
  secondLabel: "Shipping Method",
  rateKey: "rate",
  rateLabel: "Outbound Rate",
  note: "Outbound cost per courier and Shopify shipping method; used when no service cost matches the booked service.",
};

const partnerReturnRatesConfig = {
  resource: "partner-return-rates",
  title: "Partner Return Rate",
  lookup: "partners",
  secondKey: "partner_id",
  secondNameKey: "partner_name",
  secondLabel: "Partner",
  rateKey: "return_rate",
  rateLabel: "Return Rate",
  note: "Return cost per courier and marketplace partner; overrides the courier's default return rate for that partner's refunds.",
};

const TABS = [
  { id: "service", label: "Service Costs" },
  { id: "shipping", label: "Shipping Method Rates" },
  { id: "carrier", label: "Carrier Defaults" },
  { id: "partner", label: "Partner Return Rates" },
];

function CourierServiceCosts() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("service");

  // Courier dropdown shared by every tab.
  useEffect(() => {
    dispatch(getCourierServiceCostDeliveryPartners());
  }, [dispatch]);

  const dataMenu = [
    {
      type: 0,
      text: "Settings",
    },
    {
      type: 1,
      text: "Courier Costs",
    },
  ];

  return (
    <Fragment>
      <Container fluid={true} className="product-wrapper">
        <Breadcrumb data={dataMenu} title="Courier Costs" />
        <Nav tabs className="mb-3">
          {TABS.map((tab) => (
            <NavItem key={tab.id}>
              <NavLink className={classnames({ active: activeTab === tab.id })} style={{ cursor: "pointer" }} onClick={() => setActiveTab(tab.id)}>
                {tab.label}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        {/* WHY: only the active pane is mounted, so each tab fetches its own data when opened. */}
        <TabContent activeTab={activeTab}>
          <TabPane tabId="service">{activeTab === "service" && <ServiceCostsTab />}</TabPane>
          <TabPane tabId="shipping">{activeTab === "shipping" && <PairRateTab config={shippingRatesConfig} />}</TabPane>
          <TabPane tabId="carrier">{activeTab === "carrier" && <CarrierDefaultsTab />}</TabPane>
          <TabPane tabId="partner">{activeTab === "partner" && <PairRateTab config={partnerReturnRatesConfig} />}</TabPane>
        </TabContent>
      </Container>
    </Fragment>
  );
}

export default withReducer([{ partner: partnerReducer }])(CourierServiceCosts);
